<template>
  <div>
    <div class="modal" v-show="modal">
      <div class="modal-content">
        <modal-menu class="mb-2" :menus="menusDisponiveis" :selected="menu" @changeMenu="(m) => {this.menu = m}"/>
        <loading v-if="load"/>
        <div v-else-if="dados">
          <div v-show="menu === 1">
            <div class="alert alert-info" v-if="principal">
              Apresenta as opções de atendimento e ajuda o cliente quando o bot não entende a mensagem.
            </div>
            <div class="row" v-if="!principal">
              <div class="form-group col-md-6">
                <label class="font-weight-bold mb-0 mr-1">Tipo da Opção</label>
                <tooltip :msg="'Atendimento: responde a um assunto específico.\nMenu: apresenta outras opções ao cliente.\nBase de conhecimento: responde quando a IA identifica o assunto na mensagem.'"/>
                <select class="form-control" v-model="dados.tipo_opcao" :disabled="fluxo && !master">
                  <option value="1">Atendimento</option>
                  <option value="2">Menu</option>
                  <option value="3">Base de conhecimento</option>
                </select>
              </div>
              <div class="form-group col-md-6">
                <label class="font-weight-bold mb-0">Número da Opção</label>
                <input v-if="dados.tipo_opcao === '3'" key="base-conhecimento" type="text" class="form-control" value="#" disabled/>
                <input v-else key="numero-opcao" type="number" class="form-control" min="1" max="99" v-model="dados.step"/>
              </div>
            </div>
            <div class="form-group" v-if="!principal">
              <label class="font-weight-bold mb-0">Nome da Opção</label>
              <input type="text" class="form-control" placeholder="Ex: Fazer um pedido" maxlength="64" v-model="dados.nome_opcao"/>
            </div>
            <div class="form-group">
              <label class="font-weight-bold mb-0">{{ principal ? 'Mensagem' : 'Resposta' }}</label>
              <textarea rows="7" id="mensagem" class="form-control" placeholder="Ex: Para fazer seu pedido.." maxlength="512" v-model="dados.resposta" :disabled="fluxo && !master" style="resize: none"></textarea>
              <div class="d-flex mt-2" v-if="!fluxo || master">
                <select class="form-control mr-1" v-model="variavel">
                  <option value="">Selecione uma variável</option>
                  <option :value="v.tag" v-for="v in variaveis">{{ v.nome }}</option>
                </select>
                <button class="btn btn-sm btn-secondary px-3 text-nowrap rounded" @click="addVariavel()" :disabled="!variavel"><i class="fa fa-plus"></i> Adicionar</button>
              </div>
            </div>
            <div class="mb-2">
              <label class="mb-3 mr-1">
                <input type="checkbox" class="mr-1" :checked="dados.transferir === '1'" @change="dados.transferir = (dados.transferir === '1' ? '0' : '1')" :disabled="fluxo && !master">
                Transferir atendimento
              </label>
              <tooltip msg="Ao selecionar esta opção o sistema irá finalizar o atendimento e chamar um atendente."/>
            </div>
          </div>
          <div v-show="menu === 2">
            <div class="form-group">
              <label class="mb-1">
                <input type="checkbox" class="mr-1" :checked="Number(dados.adaptar_resposta) === 1" @change="dados.adaptar_resposta = $event.target.checked ? 1 : 0" :disabled="fluxo && !master">
                Adaptar resposta com IA
              </label>
              <small class="d-block text-muted">No classificador dinâmico, adapta o texto à pergunta usando as informações cadastradas. Se falhar, envia a resposta original.</small>
            </div>
            <div class="form-group">
              <label class="font-weight-bold mb-0">Contexto para classificação</label>
              <textarea rows="7" class="form-control" style="resize: none" v-model="dados.contexto" maxlength="512" :disabled="fluxo && !master" placeholder="Explique quando escolher esta opção, com exemplos e exceções."></textarea>
              <small class="text-muted">Opcional. Orienta a IA e não é enviado ao cliente.</small>
            </div>
          </div>
        </div>
        <div class="modal-bottom d-flex justify-content-between border-top">
          <button type="button" class="btn btn-outline-dark px-4 py-2" @click="fechar()">Fechar</button>
          <button class="btn btn-primary px-4 py-2" @click="confirmarSalvar()" :disabled="load" v-if="!fluxo || master">Salvar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/commons/Loading";
import ModalMenu from "@/components/commons/ModalMenu";
import Tooltip from "@/components/commons/Tooltip";
export default {
  name: "Opcoes",
  components: {Tooltip, ModalMenu, Loading},
  props: ['fluxo','master'],
  data() {
    return {
      token: localStorage.getItem('key'),
      modal: false,
      load: false,
      dados: null,
      principal: false,
      variavel: '',
      menu: 1,
      menus: [
        { nome: 'Dados', active: true },
        { nome: 'Avançado', active: true }
      ],
      variaveis: [
        { tag: '{nome_cliente}', nome: 'Nome do cliente' },
        { tag: '{nome_empresa}', nome: 'Nome da empresa' },
        { tag: '{telefone_empresa}', nome: 'Telefone da empresa' },
        { tag: '{nome_bot}', nome: 'Nome do Bot' },
        { tag: '{icone_bot}', nome: 'Ícone do Bot' },
        { tag: '{link}', nome: 'Link do cardápio' },
        { tag: '{cardapio}', nome: 'Arquivo ou link do cardápio' },
        { tag: '{tempo_espera}', nome: 'Tempo para ser atendido' },
        { tag: '{horario_empresa}', nome: 'Horários de funcionamento da empresa' },
        { tag: '{taxa_empresa}', nome: 'Taxa e tempo das entregas da empresa' },
        { tag: '{formas_pagamento}', nome: 'Formas de pagamento disponíveis' },
        { tag: '{endereco_empresa}', nome: 'Endereço da empresa' },
        { tag: '{link_promocao}', nome: 'Link das promoções' },
        { tag: '{separar}', nome: 'Separar mensagem' },
      ]
    }
  },

  computed: {
    menusDisponiveis() {
      return this.menus.map((item, index) => ({ ...item, active: index === 1 ? !this.principal : item.active }));
    }
  },

  methods: {
    openOpcao(id_opcao) {
      this.menu = 1;
      this.dados = null;

      if (id_opcao) {
        this.load = true;
        this.$http.get(`chatbot/opcoes/${this.token}/${id_opcao}`)
          .then(response => {
            this.load = false;
            this.dados = { contexto: '', tipo_opcao: '1', adaptar_resposta: 0, ...response.data };
            this.dados.tipo_opcao = String(this.dados.tipo_opcao || 1);
            this.principal = this.dados.step !== null && Number(this.dados.step) === 0;

          }, res => {
            this.load = false;
            this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
          });

      } else {
        this.load = false;
        this.principal = false;
        this.dados = {
          id_fluxo: this.fluxo || null,
          nome_opcao: '',
          contexto: '',
          adaptar_resposta: 0,
          tipo_opcao: '1',
          resposta: '',
          transferir: '0',
          opcoes: [],
          step: 1
        }
      }

      this.modal = true;
    },

    confirmarSalvar() {
      if (this.dados.id_fluxo) {
        this.$swal({
          text: "Atenção! Você está alterando um fluxo do sistema, todas as alterações serão refletidas em todos os clientes que usam este fluxo. Deseja continuar?",
          buttons: ["Cancelar", "Sim"],
          dangerMode: true
        }).then((result) => {
          if (result) {
            this.salvar()
          }
        });

      } else {
        this.salvar()
      }
    },

    salvar() {
      const baseConhecimento = this.dados.tipo_opcao === '3';

      if (this.principal) {
        this.dados.nome_opcao = 'Principal';
        this.dados.step = '0';
      }

      if (baseConhecimento && !this.principal) {
        this.dados.step = null;
      }

      if ((!baseConhecimento && (this.dados.step === null || this.dados.step === '')) || !this.dados.nome_opcao || !this.dados.resposta) {
        this.$swal("Por favor informe o nome, a resposta e, para opções de atendimento ou menu, o número.");
        return;
      }

      if (this.dados.step > 127) {
        this.$swal("O número máximo permitido é '127' para uma opção.");
        return;
      }

      this.load = true;
      this.dados.fluxo = this.fluxo;

      this.$http.post('chatbot/opcoes/' + this.token, this.dados)
        .then(res => {
          this.load = false;

          if (res.data.msg) {
            this.$swal("Opção Salva", res.data.msg);

          } else {
            this.$swal("Opção salva com sucesso!");
          }

          this.fechar();
          this.$emit('atualizar');

        }, res => {
          console.log(res);
          this.load = false;
          this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
        });
    },

    fechar() {
      this.modal = false;
    },

    addVariavel() {
      this.dados.resposta += `\n${this.variavel}`;
      this.variavel = '';
      this.$nextTick(() => {
        const elText = document.getElementById('mensagem');

        if (elText) {
          elText.scrollTop = elText.scrollHeight;
          elText.focus();
        }
      })
    }
  }
}
</script>

<style scoped>
.modal {
  display: block; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 9990; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
}

/* Modal Content/Box */
.modal-content {
  background-color: #fefefe;
  margin: 30px auto 40px;
  padding: 16px 15px 74px;
  border-radius: 4px;
  width: 450px;
  position: relative;
  height: calc(100vh - 70px);
  overflow: auto;
}

.modal-bottom {
  background-color: #FFFFFF;
  position: fixed;
  width: 450px;
  padding: 16px 15px;
  border-radius: 0 0 4px 4px;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
  border: 1px solid;
}

@media (max-width: 767px) {
  .modal-content {
    margin: 10px auto;
    width: 95%!important;
    max-width: none;
    height: calc(100vh - 20px);
    padding-bottom: 88px;
  }

  .modal-bottom {
    width: 95%!important;
    bottom: 10px;
  }
}
</style>
